export default "__VITE_ASSET__JqJKK_c6__"